import React from "react";

// public/chi/catch_phrase/th.svg をインライン化したもの。
// <img> 経由だと SVG が独立ドキュメント扱いになり Google Fonts の Kanit を
// 読めないため、タイ語だけ DOM に直接埋め込んでウェブフォントを効かせる。
// index.css の html[lang^="th"] body * が font-family を !important で上書きするため、
// --thai-font-family を差し替えることで Kanit を当てる。
const FONT_FAMILY = '"Kanit", sans-serif';
const FONT_WEIGHT = 200; // Kanit ExtraLight
const FONT_SIZE = 35;
const LINE_Y = [100, 151, 202];

const LINES = ["เสียงเพรียก", "จากเหล่า", "ผู้แสวงหาความจริง"];

export default function ThaiCatchPhrase() {
  return (
    <svg
      viewBox="0 0 414 417"
      width="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block", "--thai-font-family": FONT_FAMILY }}
    >
      <defs>
        <filter
          id="thai-catch-phrase-glow"
          x="-70"
          y="-132"
          width="550"
          height="550"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="75" />
        </filter>
      </defs>
      <circle
        cx="205"
        cy="143"
        r="124"
        fill="#060609"
        filter="url(#thai-catch-phrase-glow)"
      />
      <g
        fill="white"
        textAnchor="middle"
        style={{
          fontFamily: FONT_FAMILY,
          fontSize: FONT_SIZE,
          fontWeight: FONT_WEIGHT,
        }}
      >
        {LINES.map((line, index) => (
          <text key={line} x="207" y={LINE_Y[index]}>
            {line}
          </text>
        ))}
      </g>
    </svg>
  );
}
